module.exports = __webpack_public_path__ + "static/media/minus.c1d2458c.svg";